/**
 * Lightweight logger utility to centralize debug printing and make it easy
 * to enable/disable verbose logs depending on the runtime environment.
 *
 * Behavior:
 * - By default 'warn' and 'error' always print.
 * - 'info' and 'debug' only print when verbose logging is enabled.
 * - Verbose logging is enabled when any of:
 *   - import.meta.env.VITE_ENABLE_VERBOSE_LOGS === 'true'
 *   - Running in Vite dev mode AND the hostname is localhost / 127.0.0.1 / ::1
 */

const isLocalHost = (): boolean => {
  try {
    const host = window.location.hostname
    return host === 'localhost' || host === '127.0.0.1' || host === '::1'
  } catch (e) {
    return false
  }
}

const VERBOSE_FLAG = (import.meta.env.VITE_ENABLE_VERBOSE_LOGS === 'true') || (import.meta.env.DEV && isLocalHost())

export const isVerboseLogging = (): boolean => VERBOSE_FLAG

export const debug = (...args: any[]) => {
  if (VERBOSE_FLAG) console.debug(...args)
}

export const info = (...args: any[]) => {
  if (VERBOSE_FLAG) console.info(...args)
}

export const warn = (...args: any[]) => {
  console.warn(...args)
}

export const error = (...args: any[]) => {
  console.error(...args)
}

export default { debug, info, warn, error, isVerboseLogging }
